import styled from 'styled-components';

export const FirstStripCheckout = styled.div`
  display: flex;
  width: 100vw;
  flex: none;
  height: 10vw;
  justify-content: center;
  font-family: 'Outfit', sans-serif;
  font-size: 12px;
  background-color: black;
  color: white;
  align-items: flex-end;
  flex: none;

  span {
    font-weight: 300;
    margin-bottom: 9px;
    text-align: center;
    background-color: black;
  }
`;

export const PadLockIcon = styled.img`
  width: 2.432vw;
  height: 2.781vw;
  margin: 0 2.5066vw 2.9333vw 0;
`;

export const SecondStripCheckout = styled.div`
  display: flex;
  flex: none;
  width: 89.333vw;
  font-family: 'Outfit', sans-serif;
  margin: 5.333vw 0 5.333vw 0;
  align-items: center;
  p {
    font-weight: 300;
    font-size: 5.333vw;
  }
`;

export const LogoIcon = styled.img`
  width: 10.341vw;
  height: 14.253vw;
  margin: 0 2.586vw 0 0;
`;
